/**
 * A set of errors that need translating before they reach the user.
 */
export enum AmplifyError {
    NotAuthorizedException = "NotAuthorizedException",
    UserNotFoundException = "UserNotFoundException",
    InvalidPasswordException = "InvalidPasswordException",
}

/**
 * A set of user-friendly errors.
 */
export enum ErrorMessage {
    InvalidLoginCredentials = "Invalid username or password",
    InvalidChangePasswordCredentials = "Password reset failed",
    InvalidNewPassword = "Password does not meet requirements",
    PasswordsMismatch = "Passwords do not match",
    NewPasswordRequired = "Please set a new password to continue",
    SessionExpired = "Your session has expired. Please log in again",
    Default = "Something went wrong",
}
